var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlas = function SvgMagnifyingGlas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.76h1.17a.59.59 0 0 0 .59-.52 4.73 4.73 0 0 1 4.15-4.15.59.59 0 0 0 .53-.58v-1.19a.57.57 0 0 0-.65-.58 7.06 7.06 0 0 0-6.38 6.38.58.58 0 0 0 .59.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.65 38.16-5.8-5.8a2.93 2.93 0 0 1-.33-3.77 11.76 11.76 0 1 0-9.85 4.94 11.9 11.9 0 0 0 4.64-.84 2.94 2.94 0 0 1 3.18.64l6.5 6.5a.59.59 0 0 0 .83 0l.83-.83a.6.6 0 0 0 0-.84m-25.12-16.4a9.41 9.41 0 1 1 9.41 9.42 9.43 9.43 0 0 1-9.41-9.42"
  })));
};
export default SvgMagnifyingGlas;